import { TFunction } from 'i18next';
import * as yup from 'yup';

import {
  haveEightCharLength,
  isContainNumber,
  isContainSpecialSymbol,
  isEmailFormatValid,
  isLowerCase,
  isUpperCase,
  isWithoutWhitespaces,
} from '@/utils/regexp/validations';

export const signupSchema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      name: yup
        .string()
        .trim()
        .required(
          t('validationErrors.requiredField', {
            name: t('signup.name.label'),
          }),
        )
        .min(5, t('validationErrors.atLeastFiveCharacters'))
        .max(100, t('validationErrors.noMoreThan100Characters')),
      merchantName: yup
        .string()
        .trim()
        .min(2, t('validationErrors.atLeastTwoCharacters'))
        .max(100, t('validationErrors.noMoreThan100Characters'))
        .required(
          t('validationErrors.requiredField', {
            name: t('signup.merchantName.label'),
          }),
        ),
      email: yup
        .string()
        .required(
          t('validationErrors.requiredField', {
            name: t('signup.email.label'),
          }),
        )
        .concat(isEmailFormatValid(t)),
      password: yup
        .string()
        .required(
          t('validationErrors.requiredField', {
            name: t('signup.password.label'),
          }),
        )
        .concat(isLowerCase(t))
        .concat(isUpperCase(t))
        .concat(isContainNumber(t))
        .concat(isContainSpecialSymbol(t))
        .concat(haveEightCharLength(t))
        .concat(isWithoutWhitespaces(t)),
      confirmPassword: yup
        .string()
        .required(
          t('validationErrors.requiredField', {
            name: t('signup.confirmPassword.label'),
          }),
        )
        .oneOf(
          [yup.ref('password'), null],
          t('validationErrors.passwordsMustMatch'),
        ),
      termsAgree: yup
        .bool()
        .required()
        .oneOf([true], t('validationErrors.mustBeChecked')),
      country: yup
        .string()
        .trim()
        .required(
          t('validationErrors.requiredField', {
            name: t('signup.country.label'),
          }),
        ),
      mobileNumber: yup
        .string()
        .trim()
        .required(
          t('validationErrors.requiredField', {
            name: t('signup.mobileNumber.label'),
          }),
        ),
    })
    .required();
};
